import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { RootState } from '@/store/index';

import { verifyFieldNames, verifyStatus } from '@/pages/timeline/sections/timeline/timelineSections/verify/constants'
import { keyForCodeForSection, sectionLockStatus } from '@/pages/timeline/sections/timeline/timelineSections/constants'

import VerifyView from './view';


export default function Verify(props: any) {
    const navigate = useNavigate();
    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);
    const timelineAccordionStatus = useSelector((state: RootState) => state.timelineAccordionStatusReducer.timelineAccordionStatus);
    const [isSectionLocked, setIsSectionLocked] = useState(false)

    useEffect(() => {
        handleIsSectionLocked()
    }, [timelineAccordionStatus])


    const handleIsSectionLocked = () => {
        if (timelineAccordionStatus[keyForCodeForSection.verify] === sectionLockStatus.locked) {
            setIsSectionLocked(true)
        }
    }

    const getTheFieldStatus = (fieldName: string) => {
        let status = ''
        if (fieldName === verifyFieldNames.basicDetailsStatus) {
            status = timelineDetails.basicDetailsStatus
        } else if (fieldName === verifyFieldNames.legalInfoStatus) {
            status = timelineDetails.legalInfoStatus
        } else if (fieldName === verifyFieldNames.addressDetailsStatus) {
            status = timelineDetails.addressDetailsStatus
        } else if (fieldName === verifyFieldNames.idVerificationStatus) {
            status = timelineDetails.idVerificationStatus
        } else if (fieldName === verifyFieldNames.bssDetailsStatus) {
            status = timelineDetails.bssDetailsStatus
        }
        return status
    }


    const actionRequiedForTheGiveField = (fieldName: string) => {
        let actionReq = false
        let status = getTheFieldStatus(fieldName)
        // console.log(fieldName, status)
        if (status != '') {
            if (status === verifyStatus.not_submitted) {
                actionReq = true
            } else if (status === verifyStatus.incomplete) {
                actionReq = true
            } else if (status === verifyStatus.rejected) {
                actionReq = true
            }
        }
        return actionReq
    }


    const handleRedirectToProfile = (source: string) => {
        navigate("/profile", {
            state: { 
                source: source,
                purchaseId: timelineDetails.purchaseId
            },
        });
    }


    const actionRequiredMap = useMemo(() => ({
        [verifyFieldNames.basicDetailsStatus]: actionRequiedForTheGiveField(verifyFieldNames.basicDetailsStatus),
        [verifyFieldNames.legalInfoStatus]: actionRequiedForTheGiveField(verifyFieldNames.legalInfoStatus),
        [verifyFieldNames.addressDetailsStatus]: actionRequiedForTheGiveField(verifyFieldNames.addressDetailsStatus),
        [verifyFieldNames.idVerificationStatus]: actionRequiedForTheGiveField(verifyFieldNames.idVerificationStatus),
        [verifyFieldNames.bssDetailsStatus]: actionRequiedForTheGiveField(verifyFieldNames.bssDetailsStatus)
    }), [timelineDetails]);


    return (
        <>
            <VerifyView
                timelineDetails={timelineDetails}
                actionRequiedForTheGiveField={actionRequiedForTheGiveField}
                actionRequiredMap={actionRequiredMap}
                getTheFieldStatus={getTheFieldStatus}
                handleRedirectToProfile={handleRedirectToProfile}
                isSectionLocked={isSectionLocked}
            />
        </>
    );
};


